export * from "./links/Links.resolver"
export * from "./highlights/Highlights.resolver"
export * from "./audio/Audio.resolver"
export * from "./faq/Faq.resolver"
export * from "./listOfSubpages/ListOfSubpages.resolver"
export * from "./instagram/Instagram.resolver"
export * from "./heroCarousel/HeroCarousel.resolver"
export * from "./callToAction/CallToAction.resolver"
export * from "./columns/Columns.resolver"
export * from "./content/Content.resolver"
export * from "./contentWithImage/ContentWithImage.resolver"
export * from "./downloads/Downloads.resolver"
export * from "./form/Form.resolver"
export * from "./gallery/Gallery.resolver"
export * from "./hero/Hero.resolver"
export * from "./image/Image.resolver"
export * from "./listOfArticles/ListOfArticles.resolver"
export * from "./listOfEvents/ListOfEvents.resolver"
export * from "./listOfJobs/ListOfJobs.resolver"
export * from "./listOfPois/ListOfPois.resolver"
export * from "./listOfProfiles/ListOfProfiles.resolver"
export * from "./logoGrid/LogoGrid.resolver"
export * from "./pageHeader/PageHeader.resolver"
export * from "./teasers/TeasersManual.resolver"
export * from "./video/Video.resolver"
